import React from "react";
import CvCategory from "./CvCategory";

const CvStructure = ({data, cvs}) => {

    return (
        <div>
            {data?.category && data?.category?.map((it, i) => {
                return <CvCategory key={i} data={it} depth={0} cvs={cvs}/>
            })}
        </div>
    )
}

export default CvStructure;
